class LanguageSwitcher {
  constructor() {
    this.langSwitchButton = document.querySelector("[data-lang-switch-button]");
    this.langSwitchIcon = document.querySelector("[data-lang-switch-icon]");
    this.langSwitchList = document.querySelector("[data-lang-switch-list]");
    this.isOpen = false;
    this.isMobile = window.matchMedia("(max-width: 767px)").matches;
  }

  init = () => {
    if (this.langSwitchButton) {
      this.langSwitchButton.addEventListener("click", this.toggle);
      if (!this.isMobile) this.langSwitchList.style.display = `none`;
    }
  };

  toggle = () => {
    (this.isOpen ? this.close : this.open)();
  };

  open = () => {
    this.isOpen = true;

    if (!this.isMobile) this.langSwitchList.style.display = `block`;
    this.langSwitchButton.setAttribute("aria-expanded", "true");

    this.langSwitchIcon.classList.add("is-active");

    setTimeout(() => {
      window.addEventListener("keydown", this.closeOnEscape);
      window.addEventListener("touchend", this.closeOnClickOutside);
      window.addEventListener("click", this.closeOnClickOutside);
    }, 500);
  };

  close = () => {
    this.isOpen = false;

    if (!this.isMobile) this.langSwitchList.style.display = `none`;
    this.langSwitchButton.setAttribute("aria-expanded", "false");

    this.langSwitchIcon.classList.remove("is-active");

    window.removeEventListener("keydown", this.closeOnEscape);
    window.removeEventListener("touchend", this.closeOnClickOutside);
    window.removeEventListener("click", this.closeOnClickOutside);
  };

  closeOnEscape = (event) => {
    if (event.keyCode === 27) {
      this.close();
    }
  };

  closeOnClickOutside = (event) => {
    try {
      if (this.langSwitchList.contains(event.target) === false) {
        this.close();
      }
    } catch (error) {
      // progressive
    }
  };
}

export default LanguageSwitcher;
